"use client";

import { c as _c } from "react/compiler-runtime";
import { ChartColumn, ChartLine } from "lucide-react";
import { createContext, use, useState } from "react";
import { Button } from "@/lib/components/button";
import type { ReactNode } from "react";
export type ChartStyle = "line" | "bar";
const ChartStyleContext = createContext<{
  style: ChartStyle;
  setStyle: (style: ChartStyle) => void;
}>({
  style: "line",
  setStyle: () => undefined
});
export function ChartStyleProvider(t0) {
  const $ = _c(6);
  const {
    initialStyle,
    children
  } = t0;
  const [style, setValue] = useState(initialStyle);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = value => {
      setValue(value);
      document.cookie = `analytics_chart_style=${value}; Path=/; Max-Age=31536000; SameSite=Lax`;
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const setStyle = t1;
  let t2;
  if ($[1] !== style) {
    t2 = {
      style,
      setStyle
    };
    $[1] = style;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <ChartStyleContext value={t2}>{children}</ChartStyleContext>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export function useChartStyle() {
  return use(ChartStyleContext);
}
export function ChartStyleSelector() {
  const $ = _c(4);
  const {
    style,
    setStyle
  } = useChartStyle();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["line", "bar"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== setStyle || $[2] !== style) {
    t1 = <div role="group" aria-label="Chart style" className="flex gap-0.5 rounded-md border p-0.5">{(t0 as const).map(value => <Button key={value} variant={style === value ? "secondary" : "ghost"} size="sm" className="h-7 px-2.5 text-xs" aria-pressed={style === value} onClick={() => setStyle(value)}>{value === "line" ? <ChartLine className="h-3.5 w-3.5" /> : <ChartColumn className="h-3.5 w-3.5" />}{value === "line" ? "Line" : "Bar"}</Button>)}</div>;
    $[1] = setStyle;
    $[2] = style;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}